import React from 'react';
import BodyContainer from '../bodyContainer/BodyContainer';
import DMSAccountsLocationsCardContent from './DMSSelectionComponents/DMSAccountSelectionCardContent';
import './styles/DMSSelection.scss';

const TITLE = 'Verify DMS accounts';
const DESCRIPTION = `Review the DMS accounts associated with your dealership for accuracy. \n Refer to your accounting office if you don't know which accounts are correct.`;

class DMSSelection extends React.Component {
  render() {
    return (
      <BodyContainer title={TITLE} description={DESCRIPTION}>
        <div className="select-dms-account-body">
          <DMSAccountsLocationsCardContent
            disableNextButton={this.props.disableNextButton}
            {...this.props}
          />
        </div>
      </BodyContainer>
    );
  }
}

export default DMSSelection;